import { ITurnoBody, ITurnoEdit, ITurnoListRequest } from "../../Interfaces/auxiliar/ITurno";
import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";
const turno = "Turno";

const ListarTurnos = (request: ITurnoListRequest) => {
   return fetchListVerificacion.post(`${turno}/ListarTurno`, request);
};

const UpdateTurno = (request: ITurnoEdit) => {
   return fetchListVerificacion.put(`${turno}/ActualizarTurno`, request);
};

const CrearTurno = (request: ITurnoBody) => {
   return fetchListVerificacion.post(`${turno}/CrearTurno`, request);
};

const EliminarTurno = (turnoId: string) => {
   return fetchListVerificacion.delete(`${turno}/EliminarTurno?TurnoId=${turnoId}`);
}

const Comboturno = (request: Ifilter, controller = new AbortController()) => {
   return fetchListVerificacion.get(`${turno}/Combo`, {
      params: request,
      signal: controller.signal,
   });
};

export const TurnoService = {
   ListarTurnos,
   UpdateTurno,
   CrearTurno,
   EliminarTurno,
   Comboturno
}
